//@flow
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import SelectInput from '$common/components/SelectInput'
import changeLocale from '$src/i18n/sagas/changeLocale'
import {selectLocale} from '$src/i18n/selectors'
import {type Locale} from '$src/i18n/types'

const locales: Array<{key: Locale, label: string}> = [
  {key: 'fi', label: 'Finnish'},
  {key: 'en', label: 'English'},
  {key: 'sv', label: 'Swedish'},
]

type Props = {
  locale: string
}

class LocaleSelector extends Component<Props> {
  changeLocale = (newLocale: Locale) =>
    this.context.runSaga(changeLocale, newLocale)

  render() {
    return (
      <SelectInput
        onChange={this.changeLocale}
        value={this.props.locale}
        items={locales}
      />
    )
  }
}

LocaleSelector.contextTypes = {runSaga: PropTypes.any}

const stateToProps = state => {
  return {
    locale: selectLocale(state),
  }
}

export default connect(stateToProps)(LocaleSelector)



// WEBPACK FOOTER //
// ./src/i18n/components/LocaleSelector/index.js